<template>
  <!--  合作  -->
  <div>
    <div class="show-title"><span>优质流量 合作共赢</span></div>
    <div class="circle-box">
      <div class="circleProgress_wrapper">
        <div class="wrapper right">
          <div class="circleProgress rightCircle"></div>
        </div>
        <div class="wrapper left">
          <div class="circleProgress leftCircle"></div>
        </div>
          <div class="introduce_box">
          <div class="introduce">
            独家授权
          </div>
          <div class="introduce">
            众多媒体
          </div>
        </div>
      </div>
      <div class="circleProgress_wrapper">
        <div class="wrapper right">
          <div class="circleProgress rightCircle"></div>
        </div>
        <div class="wrapper left">
          <div class="circleProgress leftCircle"></div>
        </div>
          <div class="introduce_box">

          <div class="introduce">
            100%流量
          </div>
          <div class="introduce">
            资源直签
          </div>
        </div>
      </div>
      <div class="circleProgress_wrapper">
        <div class="wrapper right">
          <div class="circleProgress rightCircle"></div>
        </div>
        <div class="wrapper left">
          <div class="circleProgress leftCircle"></div>
        </div>
        <div class="introduce_box">
          <div class="introduce">
            日均曝光
          </div>
          <div class="introduce">
            1.5亿+次
          </div>
        </div>
      </div>
      <div class="circleProgress_wrapper">
        <div class="wrapper right">
          <div class="circleProgress rightCircle"></div>
        </div>
        <div class="wrapper left">
          <div class="circleProgress leftCircle"></div>
        </div>
        <div class="introduce_box" >
          <div class="introduce">
            一站式管理
          </div>
          <div class="introduce">
            上千广告位
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LaWinCooperation",
  data() {
    return {}
  },
  mounted() {

  },
  methods: {}
}
</script>

<style scoped>
/* 顶部标题 */
.show-title {
  color: #212529;
  padding-top: 40px;
  font-size: 2rem;
  height: 80px;
  text-align: center;
}

.circle-box {
  width: 1600px;
  margin: auto;
  justify-content: space-between;
  display: flex;
}

/* 圆形框 */
.circleProgress_wrapper {
  width: 200px;
  height: 200px;
  margin: 50px auto;
  position: relative;
}

.wrapper {
  width: 100px;
  height: 200px;
  position: absolute;
  top: 0;
  overflow: hidden;
}

.right {
  right: 0;
}

.left {
  left: 0;
}

.circleProgress {
  width: 160px;
  height: 160px;
  border: 20px solid rgb(232, 232, 12);
  border-radius: 50%;
  position: absolute;
  top: 0;
  transform: rotate(45deg);
}

.rightCircle {
  border-top: 20px solid rgb(81, 197, 81);
  border-right: 20px solid rgb(81, 197, 81);
  right: 0;
  animation: circleProgressLoad_right 2s linear 1;
}


.leftCircle {
  border-bottom: 20px solid rgb(81, 197, 81);
  border-left: 20px solid rgb(232, 232, 12);
  left: 0;
  animation: circleProgressLoad_left 2s linear 1;
}

.circleProgress_wrapper:hover .rightCircle{
  animation: circleProgressLoad_right1 2s linear 1;
}
.circleProgress_wrapper:hover .leftCircle{
  animation: circleProgressLoad_left1 2s linear 1;
}

.introduce_box {
  position: absolute;
  top: 35px;
  left: 35px;
  width: 130px;
  height: 130px;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  animation: introduce_animation 2s linear 1;
}
.introduce {
  font-size: 25px;
}

/* 中间介绍 */
@keyframes introduce_animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes circleProgressLoad_right1 {
  0% {
    border-top: 20px solid rgb(232, 232, 12);
    border-right: 20px solid rgb(232, 232, 12);
    transform: rotate(45deg);
  }
  50% {
    border-top: 20px solid rgb(232, 232, 12);
    border-right: 20px solid rgb(232, 232, 12);
    border-left: 20px solid rgb(81, 197, 81);
    border-bottom: 20px solid rgb(81, 197, 81);
    transform: rotate(225deg);
  }
  100% {
    border-left: 20px solid rgb(81, 197, 81);
    border-bottom: 20px solid rgb(81, 197, 81);
    transform: rotate(225deg);
  }
}

@keyframes circleProgressLoad_left1 {
  0% {
    border-bottom: 20px solid rgb(232, 232, 12);
    border-left: 20px solid rgb(232, 232, 12);
    transform: rotate(45deg);
  }
  50% {
    border-bottom: 20px solid rgb(232, 232, 12);
    border-left: 20px solid rgb(232, 232, 12);
    border-top: 20px solid rgb(81, 197, 81);
    border-right: 20px solid rgb(81, 197, 81);
    transform: rotate(45deg);
  }
  100% {
    border-top: 20px solid rgb(81, 197, 81);
    border-right: 20px solid rgb(81, 197, 81);
    border-bottom: 20px solid rgb(232, 232, 12);
    border-left: 20px solid rgb(232, 232, 12);
    transform: rotate(135deg);
  }
}

@keyframes circleProgressLoad_right {
  0% {
    border-top: 20px solid rgb(232, 232, 12);
    border-right: 20px solid rgb(232, 232, 12);
    transform: rotate(45deg);
  }
  50% {
    border-top: 20px solid rgb(232, 232, 12);
    border-right: 20px solid rgb(232, 232, 12);
    border-left: 20px solid rgb(81, 197, 81);
    border-bottom: 20px solid rgb(81, 197, 81);
    transform: rotate(225deg);
  }
  100% {
    border-left: 20px solid rgb(81, 197, 81);
    border-bottom: 20px solid rgb(81, 197, 81);
    transform: rotate(225deg);
  }
}

@keyframes circleProgressLoad_left {
  0% {
    border-bottom: 20px solid rgb(232, 232, 12);
    border-left: 20px solid rgb(232, 232, 12);
    transform: rotate(45deg);
  }
  50% {
    border-bottom: 20px solid rgb(232, 232, 12);
    border-left: 20px solid rgb(232, 232, 12);
    border-top: 20px solid rgb(81, 197, 81);
    border-right: 20px solid rgb(81, 197, 81);
    transform: rotate(45deg);
  }
  100% {
    border-top: 20px solid rgb(81, 197, 81);
    border-right: 20px solid rgb(81, 197, 81);
    border-bottom: 20px solid rgb(232, 232, 12);
    border-left: 20px solid rgb(232, 232, 12);
    transform: rotate(135deg);
  }
}
</style>